import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import {
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import {
  FindTradeTableDefinitionFactory,
  ProfilePromiseActionService,
  ProfileSettingKeys,
  SystemConfigPromiseService,
  Roles,
  CurrencyPairGroupLookupService,
} from "shared/cubiq-services";
import { FindActionPrimaryService } from "../../shared/cubiq-services/action/impl/FindActionPrimaryService";

import { BfxFind } from "../bfx-find/bfx-find";
import { BfxTradeBlotterComponent } from "../bfx-blotter-trade/bfx-trade-blotter.component";

import { GoldenLayoutComponent } from "../golden-layout/golden-layout-component";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";
import { LogoutNotificationService } from "../bfx-auth/logout-notification.service";
import { BfxFindDealsFilterViewComponent } from "app/bfx-find-deals/bfx-find-deals-filter-view.component";
import { BfxFindDealsContextMenuService } from "app/bfx-find-deals/bfx-find-deals-contextmenu.service";
import { BfxFindDealsService } from "../bfx-find-deals/bfx-find-deals.service";
import { BfxUserProfileService } from "../bfx-common/services/bfx-user-profile.service";
import { BfxClipboardService } from "shared/helper-services/bfx-clipboard.service";
import { BfxFindFilterCondition } from "app/bfx-find/models/BfxFindFilterCondition";

@Component({
  selector: `bfx-find-deals`,
  templateUrl: "./html/bfx-find-deals.html",
  standalone: false,
})
export class BfxFindDealsComponent
  extends BfxFind<CubiqTS.OrderDataImpl, FindTradeTableDefinitionFactory>
  implements OnInit, OnDestroy, GoldenLayoutComponent
{
  @ViewChild("embeddedBlotter", { static: true })
  public embeddedBlotter: BfxTradeBlotterComponent;

  @ViewChild("filterView", { static: true })
  protected filterView: BfxFindDealsFilterViewComponent;

  protected embeddedOrderColumnAllowListOverrideConfig: Map<string, object> = new Map<
    string,
    object
  >([]);
  protected readonly profileKey: string = `${ProfileSettingKeys.userProfileFindBlotter}/${
    CubiqTS.BlotterType[CubiqTS.BlotterType.TRADE]
  }`;
  protected readonly profileVersion: string = `2018091102`;
  public isIntentStyled: boolean = false;
  public canExport: boolean = false;

  constructor(
    _clipboardService: BfxClipboardService,
    columnSelectorService: BfxBaseBlotterColumnSelectorService,
    cd: ChangeDetectorRef,
    ngZone: NgZone,
    elementRef: ElementRef,
    goldenLayoutService: GoldenLayoutService,
    public contextMenuService: BfxFindDealsContextMenuService,
    profileActionService: ProfilePromiseActionService,
    logoutNotificationService: LogoutNotificationService,
    findService: BfxFindDealsService,
    protected findActionService: FindActionPrimaryService,
    tableDefinitionFactory: FindTradeTableDefinitionFactory,
    protected userProfileService: BfxUserProfileService,
    protected systemConfigService: SystemConfigPromiseService,
    protected currencyPairGroupService: CurrencyPairGroupLookupService,
  ) {
    super(
      _clipboardService,
      cd,
      ngZone,
      elementRef,
      goldenLayoutService,
      findService,
      contextMenuService,
      profileActionService,
      logoutNotificationService,
      userProfileService,
      tableDefinitionFactory,
      currencyPairGroupService,
    );

    systemConfigService
      .hasRole(Roles.ROLE_ORDER_EXPORT)
      .then((hasRole) => (this.canExport = hasRole));

    this.initSearchClickHandler();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.embeddedBlotter != null) {
      this.embeddedBlotter.blotterId = "bfx-find-deals";
    }
  }

  initSearchClickHandler() {
    this.filterViewResponseObservableSub = this.findService
      .getFilterViewResponseObservable()
      .subscribe((data) => {
        this.findActionService.findDeals(this.transformData(data)).then(
          (response) => {
            logger.out.info("FindDeals: Showing search results");
            this.inProgress = false;
            let a = response as any;
            this.captionLabel = a.captionLabel;
            this.showResults(a.results);
            logger.out.info("FindDeals: search results shown");
          },
          (err) => {
            this.captionLabel = err?.toString() ?? `Unknown error`;
            this.inProgress = false;
            logger.out.info(`FindDeals: Error processing search results ${this.captionLabel}`);
            this.showResults([]);
          },
        );
      });
  }

  /**
   * @override Risk trades toggle
   */
  protected createNewFavorite(name: string): void {
    this.favoriteConfig[name] = this.filterView.saveData();

    if (!Array.isArray(this.favoriteConfig[name])) {
      logger.out.warn(
        `${this.constructor.name}: Filter data not an array. Could not store` +
          ` client/risk filter mode.`,
      );
    }

    this.updateConfiguration();

    this.restoreFavoriteConfig(this.favoriteConfig);
  }

  /**
   * @override Risk trades toggle
   */
  selectFavorite(data): void {
    let favoriteName = data.filterName;

    // Reset the filter view and toggle
    this.filterView?.onClearRequest();

    let favoriteData = this.favoriteConfig[favoriteName];

    this.filterView.restoreData(favoriteData);

    // Clears results
    this.handleSearchClick();
  }

  /**
   * @override Risk trades toggle
   */
  handleClearClick(): void {
    super.handleClearClick();
  }
}
